import React from "react";

const WhatIsSaudi = () => {
  return (
    <div className="pccHeadContentContainer">
      <h2>
        {" "}
        Understanding Saudi Arabia <span>PCC</span> Verification{" "}
      </h2>
      <p>
        Saudi Arabia PCC verification involves obtaining a Police Clearance
        Certificate from the applicant's home country (India) and having it
        attested to verify its authenticity for use in Saudi Arabia. The process
        ensures compliance with Saudi legal requirements and enhances the
        document's recognition by Saudi authorities.
      </p>
    </div>
  );
};

export default WhatIsSaudi;
